import type { ClientInfraNotes } from './index';

export const OREGON_CLIENT_ID = '4879615486';

export const oregonNotes: ClientInfraNotes = {
  clientName: 'State of Oregon',
  protocol: {
    actual: 'TS over SRT',
    note: 'Despite rtmp:// in the URI, all Haivision encoders use SRT',
  },
  portPattern: '10000 + encoder number (e.g., OR-Encoder-1 = port 10001)',
  configLocation: {
    system: 'Wowza Streaming Engine Manager',
    path: 'srcEncoders application → Stream Files',
    credentials: '1Password → search "Ingress monitoring - Wowza"',
    url: 'http://ingress.state-oregon-cloud.invintus.stream:8088/enginemanager/login.htm',
  },
  notes: [
    {
      title: 'Stream naming',
      description: 'Wowza uses OR-Encoder-X.stream format. DB streamName (e.g., OR-247) is logical only.',
    },
    {
      title: 'Adding new encoders',
      description: 'Create new .stream file in Wowza with next available port. CTO typically handles this.',
    },
  ],
};
